import Link from "../Link";

const SQL = () => {
    return (
        <div>
            <Link url="https://campus.open-bootcamp.com/cursos/53" title={"OpenBootcamp SQL"} />
        </div>
    );
}

export default SQL;